export const WalletEvent = {
  DepositCryptoClick: 'deposit_crypto_click',
  DepositAddressPopUpView: 'deposit_address_pop_up_view',
  DepositNetworkOpenClick: 'deposit_network_open_click',
  DepositNetworkClick: 'deposit_network_click',
  DepositWarningHideClick: 'deposit_warning_hide_click',
  AddressCopied: 'address_copied',
  DestinationTagCopied: 'destination_tag_copied',
  TradeOnWalletPageClick: 'trade_on_wallet_page_click',
  ConvertOnWalletPageClick: 'convert_on_wallet_page_click',
  FutureOnWalletPageClick: 'future_on_wallet_page_click',
  SpotOnWalletPageClick: 'spot_on_wallet_page_click',
  YourBalanceTooltipClick: 'your_balance_tooltip_click',
  YourPositionDetailClick: 'your_position_detail_click',
  PaybackClick: 'payback_click',
  AdjustLeverageClick: 'adjust_leverage_click',
  StopLossClick: 'stop_loss_click',
  ClosePositionClick: 'close_position_click',
  DepositSelectCryptoPageView: 'deposit_select_crypto_page_view',
  DepositCryptoCurrencyClick: 'deposit_crypto_currency_click',
  WithdrawSelectCryptoPageView: 'withdraw_select_crypto_page_view',
  WithdrawCryptoClick: 'withdraw_crypto_click',
  KycVerificationRequireClick: 'kyc_verification_require_click', // renamed from verify_goto_button
  VerifyCancelButton: 'verify_cancel_button',
  WithdrawalRequestSubmittedPageView: 'withdrawal_request_submitted_page_view',
  WithdrawalRequestSubmittedClick: 'withdrawal_request_submitted_click',
  TradingRebateNudgeClick: 'trading_rebate_nudge_click',
  TradingRebateNudgeCloseClick: 'trading_rebate_nudge_close_click',
  AssetTabVipBenefitClick: 'asset_tab_vip_beneift_click',

  OriginSelectorView: 'origin_selector_view',
  OriginSelectorBack: 'origin_selector_back',
  OriginSelectorComplete: 'origin_selector_complete',

  AssetTabNudgeView: 'asset_tab_nudge_view',
  AssetTabNudgeClick: 'asset_tab_nudge_click',
  AssetTabNudgeCloseClick: 'asset_tab_nudge_close_click',

  WithdrawalClick: 'withdraw_click', // renamed from send_on_wallet_page_click
  WithdrawalVerificationClick: 'withdrawal_verification_click',
} as const;

export interface WalletEventDataType {
  [WalletEvent.TradingRebateNudgeClick]: {
    identifier: string;
  };
  [WalletEvent.TradingRebateNudgeCloseClick]: {
    identifier: string;
  };
  [WalletEvent.AssetTabNudgeView]: {
    nudge_body_text: string;
    nudge_click_text: string;
  };
  [WalletEvent.AssetTabNudgeClick]: {
    nudge_body_text: string;
    nudge_click_text: string;
  };
  [WalletEvent.AssetTabNudgeCloseClick]: {
    nudge_body_text: string;
    nudge_click_text: string;
  };
  [WalletEvent.OriginSelectorComplete]: {
    origin: string;
    origin_query: string;
  };
}
